function imageUrlHelper(image: File | string | null | undefined): string {
  if (!image) return "";

  if (image instanceof File) {
    try {
      return URL.createObjectURL(image);
    } catch {
      return "";
    }
  }

  if (typeof image === "string") {
    if (image.startsWith("data:image/")) {
      return image;
    }
    return image;
  }

  return "";
}

export default imageUrlHelper;
